import { FunctionComponent } from "react";
import { AiFillWarning } from "react-icons/ai";
import WithIcon from "./WithIcon";

const ProductionEnvironmentWarningBanner: FunctionComponent<{
  isProductionEnvironment: boolean;
}> = ({ isProductionEnvironment }) => {
  return isProductionEnvironment ? (
    <div className="p-5 max-w-full bg-yellow-600 text-white">
      <div className="flex space-x-4 justify-center">
        <div className="font-space text-center text-xl">
          <WithIcon icon={<AiFillWarning />}>
            CAUTION: You are making changes to your PRODUCTION environment.
          </WithIcon>
        </div>
      </div>
    </div>
  ) : null;
};

export default ProductionEnvironmentWarningBanner;
